export default "__VITE_IMAGE_ASSET__71b7d048__";